// @flow
import React from 'react'

import type { SelectEnumRefIndexProps, SelectEnumRefIndexState, SelectItem } from './SelectEnumRefIndex'

import SelectEnumRefIndex, { getDerivedStateFromPropsLogic, getSelectOptions } from './SelectEnumRefIndex'
import ReactSelect from './SelectEnumRefIndex/ReactSelect'
import ReactSelectOption from './Manufacturer/ReactSelect/Option'

import icons from './Manufacturer/ReactSelect/icons'

const PREFERRED_OPTION_HEIGHT_IN_PIXELS: number = 50

export default class Manufacturer extends SelectEnumRefIndex<SelectEnumRefIndexProps, SelectEnumRefIndexState> {
  static getDerivedStateFromProps (nextProps: SelectEnumRefIndexProps, prevState: SelectEnumRefIndexState) {
    return getDerivedStateFromPropsLogic(nextProps, prevState, getSelectOptions)
  }

  renderReactSelect = (): Object => {
    return (
      <ReactSelect
        error={this.renderError()}
        name={this.props.name}
        onUpdate={this.handleOnUpdateValue}
        optionComponent={ReactSelectOption}
        options={addIconsToOptions(this.state.options)}
        preferredOptionHeightInPx={PREFERRED_OPTION_HEIGHT_IN_PIXELS}
        value={this.state.value}
      />
    )
  }
}

export const addIconsToOptions = (options: Array<SelectItem>): Array<SelectItem> => {
  return options.map((option) => {
    if (!!option.preferred && icons[option.value]) {
      option.preferred.icon = icons[option.value]
    }

    return option
  })
}
